import { render } from "./Edits.vue?vue&type=template&id=fecf79ae"
import script from "./Edits.vue?vue&type=script&lang=js"
export * from "./Edits.vue?vue&type=script&lang=js"
script.render = render
/* hot reload */
if (module.hot) {
  script.__hmrId = "fecf79ae"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('fecf79ae', script)) {
    api.reload('fecf79ae', script)
  }
  
  module.hot.accept("./Edits.vue?vue&type=template&id=fecf79ae", () => {
    api.rerender('fecf79ae', render)
  })

}

script.__file = "src/components/Edits.vue"

export default script